import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './GlobalTravel.css';

const GlobalTravel = () => {
  return (
   <>
    <div className="container service-section mb-5">
        
            <div className="row column-for-tab">
                <div className="col-xxl-6 col-lg-6 col-md-12 col-12 mt-5">
                    <div className="d-flex  justify-content-xxl-center justify-content-lg-start justify-content-md-center">
                        <div className="col-md-6 col-6">
                            <LazyLoadImage src="https://blueberrywebsites.azureedge.net/bbt/images/service1.png" alt="" className='ms-lg-3 ms-xxl-0' loading="lazy" effect="blur" />
                        </div>
                        <div className="col-md-4 col-4">
                            <div className="content shadow-lg p-3">
                                <h3 className="headings">Corporate Travel</h3>
                                <p className="service-text">Global business is complex, driven by worldwide goals, and shaped by regional needs and nuances. Regardless of the scope and diversity of your travel needs, we provide tailored solutions for every aspect of your business. </p>
                                <div className="carouselCaption global-btn text-black mt-1 global-btn">
                                    <a href="/corporate-travel">
                                    <button className="btn text-black  fw-bold text-uppercase">Find out more</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-6 col-lg-6 col-md-12 col-12 mt-5">
                    <div className="d-flex end">
                        <div className="col-md-4 col-4">
                            <div className="content2 shadow p-3">
                                <h3 className="headings">Global Travel Network</h3>
                                <p className="service-text">Tap into Blueberry Travel’s global network for a smooth and cost-efficient corporate travel experience. With services ranging from accommodation to local transfers and everything in between, we’ve got you covered in over 30 destinations worldwide.   </p>
                                <div className="carouselCaption text-black global-btn">
                                    <a href="/global-solution">
                                    <button className="btn text-black  fw-bold text-uppercase">Find out more</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-6 service2">
                            <LazyLoadImage src="https://blueberrywebsites.azureedge.net/bbt/images/secondpart2img.png" alt="" loading="lazy"  />
                        </div>

                    </div>
                </div>
            </div>
            <div className="row column-for-tab">
                <div className="col-xxl-6 col-lg-6 col-md-12 mt-5">
                    <div className="d-flex justify-content-xxl-center justify-content-lg-start justify-content-md-center">
                        <div className="col-md-6 col-6">
                            <LazyLoadImage src="https://blueberrywebsites.azureedge.net/bbt/images/service3.png" alt="" className='ms-lg-3 ms-xxl-0' loading="lazy" effect="blur" />
                        </div>
                        <div className="col-md-4 col-4">
                            <div className="content shadow-lg p-3">
                                <h3 className="headings">Travel and Technology</h3>
                                <p className="service-text">
                                We build customer-centric travel technology that is designed to enhance the travel experience for every stakeholder. For travel managers and busy executives, explore a range of tools and travel solutions tailored to your requirements. 
                                </p>
                                <div className="carouselCaption text-black global-btn">
                                    <a href="/tech-platform">
                                    <button className="btn text-black  fw-bold text-uppercase">Find out more</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-6 col-lg-6 col-md-12 mt-5 ">
                    <div className="d-flex end">
                        <div className="col-md-4 col-4">
                            <div className="content2 shadow p-3">
                                <h3 className="headings">Bleisure Travel</h3>
                                <p className="service-text">Our partnership with more than 2000 hotels, cruise lines, and tour operators enables us to provide our discriminating clientele with unmatched holiday experiences so that your trip will be remembered for a long time. </p>
                                <div className="carouselCaption text-black global-btn">
                                    <a href="/bliesure">
                                    <button className="btn text-black  fw-bold text-uppercase">Find out more</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-6 service2">
                            <LazyLoadImage src="https://blueberrywebsites.azureedge.net/bbt/images/service4.png" alt="" loading="lazy" />
                        </div>

                    </div>
                </div>
            </div>
        
    </div>
   </>
  )
}

export default GlobalTravel